import { useEffect, useRef } from "preact/hooks";
import { inputValue, isThinking } from "../store";
import { handleSend } from "./handlers";
import { SEND } from "./icons";

export function Composer() {
  const ref = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (ref.current) ref.current.focus();
  }, []);

  const onKey = (e: KeyboardEvent) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div class="ic-composer">
      <textarea
        ref={ref}
        value={inputValue.value}
        onInput={(e) => (inputValue.value = (e.target as HTMLTextAreaElement).value)}
        onKeyDown={onKey}
        rows={1}
        aria-label="Melding til Iskra"
        placeholder="Skriv et spørsmål …"
        disabled={isThinking.value}
      />
      <button
        class="ic-send"
        onClick={() => handleSend()}
        disabled={isThinking.value || !inputValue.value.trim()}
        aria-label="Send melding"
      >
        {SEND}
      </button>
    </div>
  );
}
